import { render } from "./growCard.vue?vue&type=template&id=0f08d78e&scoped=true"
import script from "./growCard.vue?vue&type=script&lang=js"
export * from "./growCard.vue?vue&type=script&lang=js"

import "./growCard.vue?vue&type=style&index=0&id=0f08d78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f08d78e"]])

export default __exports__